import React from 'react'
import {
  Box,
} from '@usap/uicomponents'

import {
  itemBoxStyle,
} from './style/constant'
import ItemDetail from './item'

const Items = params => {
  const { data } = params

  return (
    <Box
      overflow={itemBoxStyle.getOverflowStyle(data)}
      pad="small"
      border={itemBoxStyle.borderStyle}
      height={itemBoxStyle.height}
    >
      {
        data
          .map(item => (
            <ItemDetail
              key={item?.product?.sku}
              item={item}
            />
          ))
      }
    </Box>
  )
}

export default Items
